import type { CookieConsentConfig, CookieValue } from "vanilla-cookieconsent";

export const getCookieConsentConfig = (
  onConsent: (param: { cookie: CookieValue }) => void,
): CookieConsentConfig => ({
  guiOptions: {
    consentModal: {
      layout: "box",
      position: "bottom right",
      equalWeightButtons: false,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "left",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },

  onConsent,

  categories: {
    necessary: {
      readOnly: true,
      enabled: true,
    },
    analytics: {
      autoClear: {
        cookies: [
          {
            name: /^(_ga|_gid)/,
          },
        ],
      },
    },
  },

  language: {
    default: "en",

    translations: {
      en: {
        consentModal: {
          title: "It's cookie time!",
          description:
            'Our website uses tracking cookies to understand how you interact with it. The tracking will be enabled only if you accept explicitly. <a href="#privacy-policy" data-cc="show-preferencesModal" class="cc__link">Manage preferences</a>',
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
        },
        preferencesModal: {
          title: "Cookie preferences",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close",
          sections: [
            {
              title: "Cookie Usage",
              description:
                "I use cookies to ensure the basic functionalities of the website and to enhance your online experience.",
            },

            {
              title: "Performance and Analytics cookies",
              linkedCategory: "analytics",

              cookieTable: {
                headers: {
                  name: "Name",
                  domain: "Service",
                  description: "Description",
                  expiration: "Expiration",
                },
                body: [
                  {
                    name: "_amp",
                    domain: "Amplitude",
                    description: 'Cookie set by <a href="#das">Amplitude</a>.',
                    expiration: "Expires after 30 days",
                  },
                ],
              },
            },
          ],
        },
      },
    },
  },
  disablePageInteraction: true,
});
